import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { PremiumPageIcon, CrownIcon } from '../../../components/icons';
import FolderIcon from '@material-ui/icons/Folder';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import { GetDays, getDateInStringDocumentDDMMMYYYY } from '../../../utils/utils';
import AccessAlarmTwoToneIcon from '@material-ui/icons/AccessAlarmTwoTone';
import { trackDwebEvent } from '../../analytics';
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  welcomePaper: {
    padding: '17px 22px 22px 22px',
    // backgroundColor:'#fff1ce',
    width: '100%',
    backgroundImage: 'linear-gradient(to top, #6100ff, #0047ff)'
  },
  welcome: {
    fontSize: 29,
    fontWeight: 600,
    textAlign: 'center',
    color: "#fff",
  },
  transport: {
    //color: "#00875a"
    color: "#fff"
  },
  book: {
    color: "#fff",
    fontWeight: 500
  },
  welcomeInfo: {
    color: "#fff",
    fontSize: 20,
    textAlign: 'center'
  },
  pageIcon: {
    fontSize: 530
  },
  enjoy: {
    backgroundColor: '#ffd28f',
    padding: 18,
    fontSize: 18,
    color: "#000",
    fontWeight: 600,
    textAlign: 'center'
  },
  premiumTitle: {
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 10,
    paddingTop: 44,
  },
  benefitsList: {
    marginTop: 12,
    padding: '30px 24px'
  },
  listText: {
    color: '#0b1323',
    fontWeight: 600
  },
  check: {
    color: '#00875a'
  },
  expiry: {
    backgroundColor: '#f1f1f1',
    padding: '13px 24px 13px',
    marginTop: 14
  },
  premiumPaper: {
    backgroundColor: '#fff',
    marginTop: 32,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 32
  },
  alertIcon: {
    color: '#000',
    fontSize: 25,
    marginRight: 18
  },
  expiryMessage: {
    fontWeight: 300
  }
}));
function generate(element) {
  return [0, 1, 2].map((value) =>
    React.cloneElement(element, {
      key: value,
    }),
  );
}
const FullWidthGrid = ({ status, payments }) => {
  const classes = useStyles();
  const benefitsList = [
    "Download all the Reports (PDF, XLS)",
    "Fully integrated with Mobile App",
    "Create unlimited Trips, Parties, Trucks, and more",
    "Supported for upto 10 users"
  ];

  useEffect(() => {
    trackDwebEvent("Dweb Subscription Premium Page", {
      subscription_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
      days_to_subscription_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : ""
    });
  }, []);

  return (
    <div className={classes.root}>
      <Grid spacing={3} container>
        <Grid item xs={12} >
          <Paper className={classes.welcomePaper}>
            <h6 className={classes.welcome}>Hey! Welcome to <span className={classes.transport}>Transport</span><span className={classes.book}>Book</span> Premium</h6>
            <h6 className={classes.welcomeInfo}>You now have full access to TransportBook on Desktop as well as mobile App.</h6>
          </Paper>
          <Paper className={classes.premiumPaper}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={6}>
                  {/* <PremiumPageIcon className={classes.pageIcon} /> */}
                  <img style={{
                    width:'100%'
                  }} src={`${process.env.PUBLIC_URL}/assets/images/TransportBook-premium.svg`} alt={"TransportBook premium"} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={classes.premiumTitle}>
                  <CrownIcon /> Premium
                </div>
                <Paper className={classes.enjoy}>Enjoy the following benefits</Paper>
                <Paper className={classes.benefitsList}>
                  <List>
                    {benefitsList && benefitsList.map((text, key) => {
                      return (<ListItem key={key}>
                        <ListItemIcon>
                          <CheckIcon className={classes.check} />
                        </ListItemIcon>
                        <ListItemText
                          primary={text}
                          primaryTypographyProps={{
                            className: classes.listText,
                          }}
                        />
                      </ListItem>)
                    })}
                  </List>
                </Paper>
                <Paper className={classes.expiry}>
                  <AccessAlarmTwoToneIcon className={classes.alertIcon} />
                  <span className={classes.expiryMessage}>
                  Your Premium Expires 
                  &nbsp;{status && typeof status.numberOfDays != 'undefined' && <strong>{status.numberOfDays>1?" in "+status.numberOfDays+' Days':status.numberOfDays!=0?" in "+status.numberOfDays+' Day':'Today'}</strong>}&nbsp;{status && status.subscriptionEndDateEpoch?`(${getDateInStringDocumentDDMMMYYYY(status.subscriptionEndDateEpoch)})`:''}
                  </span>
                </Paper>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      {/* <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
            <PremiumPageIcon className={classes.pageIcon} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.premiumTitle}>
            <CrownIcon /> Premium
          </div>
          <Paper className={classes.enjoy}>Enjoy the following benefits</Paper>
          <Paper className={classes.benefitsList}>
            <List>
              {benefitsList && benefitsList.map((text,key)=>{
                  return(<ListItem key={key}>
                    <ListItemIcon>
                        <CheckIcon className={classes.check} />
                    </ListItemIcon>
                    <ListItemText
                      primary={text}
                      primaryTypographyProps={{
                          className:classes.listText,
                      }}
                    />
                  </ListItem>)
              })}
            </List>
          </Paper>
          <Paper className={classes.expiry}>
            Enjoy the following benefits
          </Paper>
        </Grid>
      </Grid> */}
    </div>
  );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullWidthGrid);